import CustomerStatistics from './customerstatistics'

export default CustomerStatistics